module.exports = __webpack_public_path__ + "static/media/userLoader.15372048.gif";